module.exports = __webpack_public_path__ + "static/media/NoSearchResult.ef886a9c.png";